import React from 'react';
import { Link } from 'react-router-dom';
import { siteData } from '../../data/mock';

const Footer = () => {
  const { footer, brand } = siteData;
  const contact = brand.contact;

  return (
    <footer className="bg-[#0a0a14] py-10 md:py-14">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">

        {/* Top row: brand + links — 2 colonne bilanciate */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-8">

          {/* Brand identity */}
          <div className="md:max-w-[420px]">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#0E47B0] rounded-md flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-sm">L</span>
              </div>
              <span className="text-white font-bold text-lg">{brand.fullName || brand.name}</span>
            </div>
            <p className="text-white/40 text-[13px] leading-[1.75] mb-3">
              Studio legale specializzato in assistenza legale per controversie relative a investimenti online, crypto e piattaforme digitali.
            </p>
            <p className="text-white/25 text-[11px] leading-[1.6]">
              {contact.ordineAvvocati}
            </p>
            <p className="text-white/20 text-[11px] mt-1">
              P.IVA: {contact.piva}
            </p>
          </div>

          {/* Legal links */}
          <div>
            <p className="text-white/50 text-[11px] font-semibold uppercase tracking-wider mb-4">Informazioni legali</p>
            <div className="space-y-2.5">
              {footer.links.map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className="block text-white/40 hover:text-white/65 text-[13px] no-underline transition-colors"
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/terms"
                className="block text-white/40 hover:text-white/65 text-[13px] no-underline transition-colors"
              >
                Disclaimer legale
              </Link>
            </div>
          </div>
        </div>

        {/* Disclaimer box */}
        <div className="bg-white/[0.03] border border-white/[0.07] rounded-lg p-4 mb-6">
          <p className="text-white/35 text-[12px] leading-[1.75] mb-2">
            {footer.disclaimer}
          </p>
          <p className="text-white/30 text-[12px] leading-[1.75]">
            {footer.disclaimer2}
          </p>
        </div>

        {/* Bottom row */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-[12px]">{footer.copyright}</p>
          <div className="flex items-center gap-6 flex-wrap justify-center">
            <Link to="/privacy-policy" className="text-white/35 hover:text-white/55 text-[12px] no-underline transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white/35 hover:text-white/55 text-[12px] no-underline transition-colors">
              Termini e Condizioni
            </Link>
            <Link to="/cookie-policy" className="text-white/35 hover:text-white/55 text-[12px] no-underline transition-colors">
              Cookie Policy
            </Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
